import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=7f0afab8&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=7f0afab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0afab8",
  null
  
)

export default component.exports